import React from 'react';
import PropTypes from 'prop-types';
import Isvg from 'react-inlinesvg';
import { useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';
import Button from 'components/Button';
import { openDecagonChat } from 'components/Decagon';
import Message from 'components/Message';
import { closeModal } from 'components/Modal';
import { ICONS, ILLUSTRATIONS } from 'constants/icons';
import { bem } from 'helpers/class-name';
import { copyToClipboard } from 'helpers/page-utils';

import { messages } from './ItemSubmitErrorModal.messages';

import './ItemSubmitErrorModal.scss';

const { block, element } = bem('item-submit-error-modal');

export const ITEM_SUBMIT_ERROR_MODAL_NAME = 'ItemSubmitErrorModal';

const ItemSubmitErrorModal = ({ currencyCode, itemName, linkToMenu, menuPrice }) => {
  const dispatch = useDispatch();
  const intl = useIntl();
  const formattedMenuPrice = intl.formatNumber(menuPrice, { style: 'currency', currency: currencyCode });

  const handleClose = () => {
    dispatch(closeModal());
  };

  const handleCopyToClipboard = () => {
    const copyText = intl.formatMessage(messages.addPricingTemplate, {
      itemName,
      menuPrice: formattedMenuPrice,
      linkToMenu,
    });
    copyToClipboard(copyText);
  };

  return (
    <div className={block()}>
      <header className={element('header')}>
        <Isvg src={ILLUSTRATIONS.errorTools} className={element('illustration')} />
        <Isvg src={ICONS.cross} className={element('close-icon')} onClick={handleClose} />
      </header>
      <section className={element('content')}>
        <div className={element('content-wrapper')}>
          <Message className={element('text-center', 'text--md', 'text--semibold')} message={messages.title} />
          <Message className={element('text-center')} message={messages.description} />
          <Button
            className={element('copy-btn')}
            onClick={handleCopyToClipboard}
            styled="tertiary"
            type={Button.TYPES.BUTTON}>
            <Isvg src={ICONS.copy2} className={element('copy-icon')} />
            <Message message={messages.copy} />
          </Button>
          <div className={element('pricing-template-container')}>
            <Message message={messages.addPricing} />
            <div className={element('pricing-template')}>
              <Message message={messages.itemName} values={{ itemName, strong: text => <strong>{text}</strong> }} />
              <Message
                message={messages.menuPrice}
                values={{ menuPrice: formattedMenuPrice, strong: text => <strong>{text}</strong> }}
              />
              <Message message={messages.menuLink} values={{ linkToMenu, strong: text => <strong>{text}</strong> }} />
            </div>
          </div>
        </div>
        <Button
          className={element('contact-btn')}
          onClick={openDecagonChat}
          styled="primary"
          type={Button.TYPES.BUTTON}>
          <Message message={messages.contactUs} />
        </Button>
      </section>
    </div>
  );
};

ItemSubmitErrorModal.propTypes = {
  currencyCode: PropTypes.string,
  itemName: PropTypes.string,
  linkToMenu: PropTypes.string,
  menuPrice: PropTypes.string,
};

export default ItemSubmitErrorModal;
